//
// Copyright (c) 2011-2022 by Curalate, Inc.
//

import { FeatureNames } from '@bvengineering/curalate-features';
import { IUrlRouterProvider } from 'angular-ui-router';

import {
  componentNameToTemplate,
  hasFeature,
  hasAllFeatures,
  IPartialState,
  lazyLoadModule,
  NavGroup,
  StateFactory,
} from 'app/initialization/routing/stateHelpers';

// Sets default values for state data
function SamplingStateFactory(state: IPartialState) {
  const accessFn = state.data?.hasAccess ?? (() => true);
  const data = {
    title: 'Sampling',
    navGroup: NavGroup.SAMPLING,
    ...state.data,
    hasAccess: () =>
      hasAllFeatures(FeatureNames.InfluensterCampaigns) && accessFn(),
  };

  return StateFactory({
    ...state,
    data,
  });
}

export function routingRules(urlRouterProvider: IUrlRouterProvider) {
  if (!hasFeature(FeatureNames.InfluensterCampaigns)) {
    urlRouterProvider.when('/sampling', '/');
  }
}

export const states = {
  sampling: SamplingStateFactory({
    url: '/sampling',
    template: componentNameToTemplate('samplingPage'),
    resolve: {
      ...lazyLoadModule(
        'curalate.sampling',
        () => import('@sampling/SamplingApp'),
      ),
    },
  }),
  'sampling.campaign-type': SamplingStateFactory({
    url: '/:campaignType',
  }),
  'sampling.campaign-details': SamplingStateFactory({
    url: '/:campaignType/:campaignId',
  }),
};
